import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

const IrrigationEventsModal = ({ show, onHide, events, date, summaryData }) => {
    const formatTime = (isoString) => {
        return new Date(isoString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    // CE/pH: lectura de inicio → pico → primera después del pico. "—" si el sensor
    // no la mide o la lectura de después todavía no ha llegado.
    const formatReading = (value, decimals) =>
        value === null || value === undefined ? '—' : Number(value.toFixed(decimals));

    const renderReadings = (before, peak, after, decimals) =>
        [before, peak, after].map((v, i) => <div key={i}>{formatReading(v, decimals)}</div>);

    const hasCe = events?.some(e => e.ceBefore != null || e.cePeak != null || e.ceAfter != null);
    const hasPh = events?.some(e => e.phBefore != null || e.phPeak != null || e.phAfter != null);

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Eventos de Riego - {date}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {summaryData && (
                    <div className="mb-4 p-3 bg-light rounded shadow-sm border">
                        <div className="row g-3 text-center">
                            <div className="col-6 col-md-4">
                                <div className="text-muted small">Fecha</div>
                                <div className="fw-bold">{date}</div>
                            </div>
                            <div className="col-6 col-md-4 border-start-md">
                                <div className="text-muted small">Total Pulsos</div>
                                <div className="fw-bold">{summaryData.pulsos}</div>
                            </div>
                            <div className="col-6 col-md-4 border-start-md">
                                <div className="text-muted small">Duración Total</div>
                                <div className="fw-bold">{summaryData.duration} min</div>
                            </div>
                            <div className="col-6 col-md-6 border-start-md">
                                <div className="text-muted small">1er Pulso</div>
                                <div className="fw-bold">
                                    {summaryData.firstPulse ? new Date(summaryData.firstPulse).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 border-start-md">
                                <div className="text-muted small">Últ. Pulso</div>
                                <div className="fw-bold">
                                    {summaryData.lastPulse ? new Date(summaryData.lastPulse).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {events && events.length > 0 ? (
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Inicio</th>
                                    <th>Pico</th>
                                    <th>Valor Inicial</th>
                                    <th>Valor Pico</th>
                                    <th>Duración (min)</th>
                                    {hasCe && (
                                        <th title="Antes / Pico / Después">
                                            CE
                                            <div className="small fw-normal text-muted">dS/m</div>
                                        </th>
                                    )}
                                    {hasPh && <th title="Antes / Pico / Después">pH</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {events.map((event, index) => (
                                    <tr key={index}>
                                        <td>{formatTime(event.startTimestamp)}</td>
                                        <td>{formatTime(event.peakTimestamp)}</td>
                                        <td>{event.initialValue.toFixed(2)} %</td>
                                        <td>{event.peakValue.toFixed(2)} %</td>
                                        <td>{event.durationMinutes}</td>
                                        {hasCe && <td className="text-nowrap">{renderReadings(event.ceBefore, event.cePeak, event.ceAfter, 3)}</td>}
                                        {hasPh && <td className="text-nowrap">{renderReadings(event.phBefore, event.phPeak, event.phAfter, 2)}</td>}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        {(hasCe || hasPh) && (
                            <p className="text-muted small mb-0">CE y pH, de arriba hacia abajo: antes, pico y después del riego.</p>
                        )}
                    </div>
                ) : (
                    <p className="text-center">No hay detalles de eventos disponibles para este día.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default IrrigationEventsModal;
